export default __webpack_public_path__ + "static/media/Hyundai-3d-model.458f84d2.png";